import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import tippy from 'tippy.js';
import global_css from './global-css';
import {ToolTippy} from './mixins/tooltippy';
import {UnlockableLitElement} from './unlockable-lit-element';

@customElement('help-icon')
export class HelpIcon extends ToolTippy(UnlockableLitElement, {
  trigger: 'click',
  delay: [0, 0],
  duration: 100,
  hideOnClick: 'toggle',
}) {
  static override styles = [
    global_css,
    css`
      /* :host {
        display: flex;
        align-items: center;
        justify-content: center;
      } */
      .help-icon {
        height: 100%;
        width: 100%;
      }
    `,
  ];
  @property() content = '';

  override tooltipContent = () => this.content;

  override render() {
    return html`<button class="help-icon">?</button>`;
  }
}
